export enum FormActionNameEnum {
  CREATE_NOTE = 'Create Note for Form',
  REPEAT_PARAGRAPH= 'Repeat Paragraph',
}
